import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  // const mainNavLinks = [
  //   { to: "/", label: "Home" },
  //   { to: "/about", label: "About Us" },
  //   { to: "/institutions", label: "Institutions" },
  //   { to: "/donors", label: "Donors" },
  //   { to: "/trustees", label: "Trustees" },
  //   { to: "/committee", label: "Committee" },
  //   { to: "/events", label: "Media" },
  //   { to: "/contact", label: "Contact" },
  // ];

  return (
    <header className="sticky top-0 z-50 border-b bg-background/80 backdrop-blur-sm">
      <div className="container mx-auto flex items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3">
          {/* <Button variant="ghost" size="icon" onClick={() => navigate("/")}>
          <ArrowLeft className="h-5 w-5" />
        </Button> */}
          <div className="flex items-center gap-3">
            <div
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-primary"
              onClick={() => navigate("/")}
            >
              <Home className="h-5 w-5 text-primary-foreground" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-foreground">JBF Portal</h1>
              <p className="text-xs text-muted-foreground">Student Inquiry</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
